module.exports = __webpack_public_path__ + "img/dark-green-circle-table-8.a222c04d.png";